export const NATIVE_APP_IS_WEBVIEW = 'native-app:is-webview';
export const NATIVE_APP_CURRENT_MERCHANT_ID = 'native-app:current-merchant-id';
export const NATIVE_APP_SESSION_TRANSFER_ID_TOKEN = 'native-app:session-transfer-id-token';
export const NATIVE_APP_SESSION_TRANSFER_ACCESS_TOKEN = 'native-app:session-transfer-access-token';
